import Day from '../components/Day';

const Days = ({ data, dataOriginName }) => {

    const days = data.daily.map((day, index) =>
        <Day key={day.date_unix} dayData={day} index={index} dataOriginName={dataOriginName} />
    )

    return (
        <div className="days__container">
            {days}
        </div>
    )
}

export default Days;
